import $ from 'jquery';

export default function footerModule() {
  const searchElement = $('.footer__navigation');
  if (searchElement.length) {
    return import(/* webpackChunkName: "footer" */ '../footer')
      .then(({ default: Footer }) => {
        const footer = new Footer();
        return footer;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
